import { Switch } from "@clockwise/design-system";
import { DateTime } from "luxon";
import React, { useEffect } from "react";
import { isAllDayBasedOnTimes } from "../../web-app-calendar/hooks/useEditExistingEvent.util";
import { EventElementsWrap } from "../atoms/EventElementsWrap";
import { useReadEventTimeDetails, useUpdateEventTimeDetails } from "../hooks/EventCardContext";
import { isValidTimeRange } from "../utils/eventCardTime.util";

export const AllDay = ({ readOnly }: { readOnly: boolean }) => {
  const { startTime, endTime, isAllDay } = useReadEventTimeDetails();
  const { setIsAllDay, setTimeError, setStartTime, setEndTime } = useUpdateEventTimeDetails();

  // Determine if new times make the event "all day"
  const isAllDayFromTimes = isAllDayBasedOnTimes(startTime, endTime);

  useEffect(() => {
    setIsAllDay(isAllDayFromTimes);
  }, [isAllDayFromTimes, setIsAllDay]);

  const validateAndCallback = (newStart: DateTime, newEnd: DateTime) => {
    setIsAllDay(!isAllDay);
    if (isValidTimeRange(newStart, newEnd)) {
      setTimeError(null);
      setStartTime(newStart);
      setEndTime(newEnd);
    } else {
      setTimeError("Start time must be before end time.");
    }
  };

  const onToggleIsAllDay = () => {
    if (!isAllDay) {
      const newEndDate = startTime.plus({ days: 1 });
      const end = endTime.set({
        year: newEndDate.year,
        month: newEndDate.month,
        day: newEndDate.day,
      });
      validateAndCallback(startTime, end);
    } else {
      const end = endTime.set({
        year: startTime.year,
        month: startTime.month,
        day: startTime.day,
      });
      validateAndCallback(startTime, end);
    }
  };

  return (
    <EventElementsWrap name="allDay">
      <div className="cw-flex cw-justify-between cw-items-center cw-flex-1 cw-h-7 cw-text-13 cw-font-medium">
        <div>All day</div>
        <Switch size="small" disabled={readOnly} checked={isAllDay} onChange={onToggleIsAllDay} />
      </div>
    </EventElementsWrap>
  );
};
